import './App.css';
import logo from './assets/hotbites-logo.png';
import homeImage from './assets/hotbites-landing.png';
import QRCode from 'react-qr-code';
import { BrowserRouter as Router, Routes, Route, useParams, Navigate, Link } from 'react-router-dom';

function HomePage() {
  return (
    <div className="App">
      <div className="hero-section">
        <div className="content-card">
          <img src={logo} alt="HotBites Logo" className="logo" />
          <div className="home-content">
            <img src={homeImage} alt="HotBites Home" className="home-image" />
            <div className="instructions">
              <h3 className="instructions-title">The HotBites Mobile App!</h3>
              <p>Questions? Contact us at: flavorhq@hotbitesplatform.com</p>
            </div>
          </div>
          <Link to="/privacy-policy" className="app-link">Privacy Policy</Link>
        </div>
      </div>
    </div>
  );
}

function PrivacyPolicyPage() {
  return (
    <div className="App">
      <div className="hero-section">
        <div className="content-card privacy-policy-page">
          <h1 className="privacy-title">Privacy Policy</h1>

          <p className="privacy-paragraph">
            This privacy policy applies to the HotBites app (hereby referred to as "Application") for mobile devices that was created by HotBites (hereby referred to as "Service Provider") as a Free service. HotBites is a recipe discovery platform that allows users to explore recipes, save favorites, and submit HotTips. This service is intended for use "AS IS".
          </p>

          <h2 className="privacy-section-title">Information Collection and Use</h2>

          <p className="privacy-paragraph">
            The Application collects information when you download and use it. This information may include:
          </p>
          <ul className="privacy-list">
            <li>The operating system you use on your mobile device</li>
            <li>Account information (email address, username) when you create an account</li>
            <li>Recipe preferences and favorites that you save</li>
            <li>HotTips you submit for recipes</li>
            <li>Search queries and browsing history to improve recipe recommendations</li>
          </ul>

          <p className="privacy-paragraph">
            The Application does not gather precise information about the location of your mobile device.
          </p>

          <p className="privacy-paragraph">
            The Service Provider uses the collected information to:
          </p>
          <ul className="privacy-list">
            <li>Provide recipe discovery and browsing features</li>
            <li>Save and manage your favorite recipes</li>
            <li>Store and display your recipe HotTips</li>
            <li>Improve the Application&apos;s functionality and user experience</li>
            <li>Analyze usage patterns to enhance recipe recommendations</li>
          </ul>

          <p className="privacy-paragraph">
            The Service Provider may use the information you provided to contact you from time to time to provide you with important information, required notices and marketing promotions.
          </p>

          <p className="privacy-paragraph">
            For a better experience, while using the Application, the Service Provider may require you to provide certain personally identifiable information, including but not limited to your email address. The information that the Service Provider requests will be retained by them and used as described in this privacy policy.
          </p>

          <h2 className="privacy-section-title">Third Party Access</h2>

          <p className="privacy-paragraph">
            Only aggregated, anonymized data is periodically transmitted to external services to aid the Service Provider in improving the Application and their service. The Service Provider may share your information with third parties in the ways that are described in this privacy statement.
          </p>

          <p className="privacy-paragraph">
            Please note that the Application utilizes third-party services that have their own Privacy Policy about handling data. Below are the links to the Privacy Policy of the third-party service providers used by the Application:
          </p>
          <ul className="privacy-list">
            <li>
              <a
                href="https://www.google.com/policies/privacy/"
                target="_blank"
                rel="noopener noreferrer"
                className="privacy-link"
              >
                Google Play Services
              </a>
            </li>
            <li>
              <a
                href="https://stripe.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="privacy-link"
              >
                Stripe
              </a>
            </li>
            <li>
              <a
                href="https://supabase.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="privacy-link"
              >
                Supabase
              </a>
            </li>
          </ul>

          <p className="privacy-paragraph">
            The Service Provider may disclose User Provided and Automatically Collected Information:
          </p>
          <ul className="privacy-list">
            <li>As required by law, such as to comply with a subpoena, or similar legal process.</li>
            <li>When they believe in good faith that disclosure is necessary to protect their rights, protect your safety or the safety of others, investigate fraud, or respond to a government request.</li>
            <li>With their trusted services providers who work on their behalf, do not have an independent use of the information disclosed to them, and have agreed to adhere to the rules set forth in this privacy statement.</li>
          </ul>

          <h2 className="privacy-section-title">Opt-Out Rights</h2>

          <p className="privacy-paragraph">
            You can stop all collection of information by the Application easily by uninstalling it. You may use the standard uninstall processes as may be available as part of your mobile device or via the mobile application marketplace or network.
          </p>

          <h2 className="privacy-section-title">Data Retention Policy</h2>

          <p className="privacy-paragraph">
            The Service Provider will retain User Provided data for as long as you use the Application and for a reasonable time thereafter. If you&apos;d like them to delete User Provided Data that you have provided via the Application, please contact them at jsfanatik@gmail.com and they will respond in a reasonable time.
          </p>

          <h2 className="privacy-section-title">Children</h2>

          <p className="privacy-paragraph">
            The Service Provider does not use the Application to knowingly solicit data from or market to children under the age of 13.
          </p>

          <p className="privacy-paragraph">
            The Application does not address anyone under the age of 13. The Service Provider does not knowingly collect personally identifiable information from children under 13 years of age. In the case the Service Provider discover that a child under 13 has provided personal information, the Service Provider will immediately delete this from their servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact the Service Provider (flavorhq@hotbitesplatform.com) so that they will be able to take the necessary actions.
          </p>

          <h2 className="privacy-section-title">Security</h2>

          <p className="privacy-paragraph">
            The Service Provider is concerned about safeguarding the confidentiality of your information. The Service Provider provides physical, electronic, and procedural safeguards to protect information the Service Provider processes and maintains.
          </p>

          <h2 className="privacy-section-title">Changes</h2>

          <p className="privacy-paragraph">
            This Privacy Policy may be updated from time to time for any reason. The Service Provider will notify you of any changes to the Privacy Policy by updating this page with the new Privacy Policy. You are advised to consult this Privacy Policy regularly for any changes, as continued use is deemed approval of all changes.
          </p>

          <p className="privacy-paragraph">
            This privacy policy is effective as of 2025-01-28.
          </p>

          <h2 className="privacy-section-title">Your Consent</h2>

          <p className="privacy-paragraph">
            By using the Application, you are consenting to the processing of your information as set forth in this Privacy Policy now and as amended by us.
          </p>

          <h2 className="privacy-section-title">Contact Us</h2>

          <p className="privacy-paragraph">
            If you have any questions regarding privacy while using the Application, or have questions about the practices, please contact the Service Provider via email at flavorhq@hotbitesplatform.com.
          </p>

          <Link to="/" className="app-link">Return Home</Link>
        </div>
      </div>
    </div>
  );
}

function NotFound() {
  return (
    <div className="App">
      <div className="hero-section">
        <div className="content-card">
          <img src={logo} alt="HotBites Logo" className="logo" />
          {/* <h1 className="error-code">404</h1> */}
          <p className="tagline">Oops! Recipe Not Found</p>
          {/* <p className="error-message">The recipe you're looking for doesn't exist or has been removed.</p> */}
          <div className="cta-buttons">
            <button className="primary-button" onClick={() => window.location.href = '/'}>
              Return Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function RecipePage() {
  const { recipe_id } = useParams();
  const appUrl = `hotbitesapp://home/recipe/${recipe_id}`;

  return (
    <div className="App">
      <div className="hero-section">
        <div className="content-card">
          <img src={logo} alt="HotBites Logo" className="logo" />
          <p className="tagline">View the recipe in the HotBites app!</p>
          <div className="qr-section">
            <QRCode 
              value={appUrl}
              size={200}
              level="H"
              className="qr-code"
            />
            <p className="qr-text">Scan to open in HotBites app</p>
          </div>
          <div className="cta-buttons">
            <button className="primary-button" onClick={() => window.location.href = appUrl}>
              Let's go!
            </button>
          </div>
          <p className="pinterest-mobile-note">
            Viewing from Pinterest? Click the three dots and select "Open in browser"
          </p>
          <a href="/" className="app-link">Get the HotBites app!</a>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/:recipe_id" element={<RecipePage />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
